import { prefixObjectValues } from '../utils';

const list = {
  card: 'listing-card-',
  sortBy: 'sort-by',
  ftesRequired: 'ftes-required',
  states: 'states',
  contractValue: 'contract-value',
  workLocation: 'work-location',
  startDate: 'start-date',
};

export default prefixObjectValues(list, 'listing-search');
